// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__Wbsnv","ranges":"BmiRanges_ranges__tb0tg"};